'use client';

// Keeps <html data-theme> in step with the stored choice and, in 'system'
// mode, with the OS underneath it. The blocking script in layout.tsx sets the
// attribute before first paint so there is no flash; this is what keeps it
// current after that — a theme picked in another tab, or daylight turning to
// evening while the console stays open.

import { useEffect, useSyncExternalStore } from 'react';
import { getServerSnapshot, getSnapshot, subscribe, type Theme } from '@/lib/theme-store';

function resolve(theme: Theme): 'light' | 'dark' {
  if (theme !== 'system') return theme;
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
}

export function ThemeSync() {
  const theme = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

  useEffect(() => {
    document.documentElement.dataset.theme = resolve(theme);
    if (theme !== 'system') return;
    const media = window.matchMedia('(prefers-color-scheme: light)');
    const onChange = () => {
      document.documentElement.dataset.theme = resolve('system');
    };
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, [theme]);

  return null;
}
